import { z } from 'zod'
import { IncomeSourceType } from '../../enums/income-source-type.enum'

export const incomeSourceResponseSchema = z.object({
  id: z.string().guid(),
  incomeId: z.string().guid(),
  sourceId: z.string(),
  sourceType: z.nativeEnum(IncomeSourceType),
  createdAt: z.coerce.date(),
})

export type IncomeSourceResponseDto = z.infer<typeof incomeSourceResponseSchema>
